import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkOrderSuggestedCategoryService {

  constructor(private apiService: ApiService) {}

  updateWorkOrderSuggestedCategorySelection(uid: string, isSelected: boolean): Observable<any> {
    return this.apiService.post('/WorkOrderSuggestedCategory/UpdateWorkOrderSuggestedCategorySelection', {
      WorkOrderSuggestedCategoryUid: uid,
      IsSelected: isSelected
    });
  }
}
